export default {
  insertYxcPurchaseDemand: '/ygsjzs/yxcPurchaseDemand/insertYxcPurchaseDemand',
  updateYxcPurchaseDemand: '/ygsjzs/yxcPurchaseDemand/updateYxcPurchaseDemand',
  deleteYxcPurchaseDemand: '/ygsjzs/yxcPurchaseDemand/deleteYxcPurchaseDemand',
  selectYxcPurchaseDemandById: '/ygsjzs/yxcPurchaseDemand/selectYxcPurchaseDemandById',
  selectYxcPurchaseDemandByPage: '/ygsjzs/yxcPurchaseDemand/selectYxcPurchaseDemandByPage',
  insertYxcPurchaseQuote: '/ygsjzs/yxcPurchaseDemand/insertYxcPurchaseQuote',
  deleteYxcPurchaseQuote: '/ygsjzs/yxcPurchaseDemand/deleteYxcPurchaseQuote',
  selectYxcPurchaseQuoteByDemandId: '/ygsjzs/yxcPurchaseDemand/selectYxcPurchaseQuoteByDemandId'
}
